module.exports = __webpack_public_path__ + "static/media/signin_logo_new.e6833927.png";